<template>
  <div v-if="$store.state.view == 'broker'" :class="{
    'ml-3' : true,
    'text-gray-500 hover:text-blue-500' : !doesPageValueExist(page), 
    'text-blue-500 hover:text-blue-600' : doesPageValueExist(page)
  }">
    <a href="#" 
      v-on:click.prevent="toggleNotepad(page)">
      <svg width="16" height="16" stroke-width="2" class="inline mx-1" stroke="currentColor" fill="none">
        <use xlink:href="/static/img/feather-sprite.svg#file-text"/>
      </svg>
    </a>
  </div>
</template>

<script>
	export default {
		props : {
			page : {
				type    : String,
				required: false
			},
		}
	}
</script>